import React from 'react';

const CurrencyCircleDollar = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M15 8.4375V10.3125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 19.6875V21.5625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 19.6875H16.4062C17.0279 19.6875 17.624 19.4406 18.0635 19.001C18.5031 18.5615 18.75 17.9654 18.75 17.3438C18.75 16.7221 18.5031 16.126 18.0635 15.6865C17.624 15.2469 17.0279 15 16.4062 15H13.5938C12.9721 15 12.376 14.7531 11.9365 14.3135C11.4969 13.874 11.25 13.2779 11.25 12.6562C11.25 12.0346 11.4969 11.4385 11.9365 10.999C12.376 10.5594 12.9721 10.3125 13.5938 10.3125H17.8125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CurrencyCircleDollar;
